<template>
  <div>
    <div class="row" style="text-align:right;">
        <div class="col-6 offset-6 form-group">
            <span style=" width: 30px; height: 30px; border-radius: 5px; background-color: #007DFC; color: white; display: inline-block; padding-left: 5px; padding-right: 5px; text-align: center; cursor: pointer; ">
                <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
            </span>

            <select style="margin-left:-1px!important;border-left:0px;margin-right:182px;" class="select"
                    id="expense_type_id"
                    @change="fetchStatement"
                    name="expense_type_id"
                    v-model="expenseTypeId">
                <option v-for="expenseType in expenseTypes" :value="expenseType.id">
                    {{
            expenseType.name
                    }}
                </option>
            </select>
            <!--<span style="
            background-color: #4586c6;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
          "><strong>Expense:</strong></span>

            <select style="margin-left:-1px!important;border-left:0px;margin-right:8px;" class="select"
                    id="expense_type_id"
                    @change="fetchStatement"
                    name="expense_type_id"
                    v-model="expenseTypeId">
                <option v-for="expenseType in expenseTypes" :value="expenseType.id">
                    {{
            expenseType.name
                    }}
                </option>
            </select>-->
        </div>
    </div>

    <div class="table-responsive">
      <table class="table table-border">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">B/L {{ year }}</th>
            <th v-bind:class="{'active-month': currentMonth == 1}"  scope="col">Jan</th>
            <th v-bind:class="{'active-month': currentMonth == 2}"  scope="col">Feb</th>
            <th v-bind:class="{'active-month': currentMonth == 3}"  scope="col">Mar</th>
            <th v-bind:class="{'active-month': currentMonth == 4}"  scope="col">Apr</th>
            <th v-bind:class="{'active-month': currentMonth == 5}"  scope="col">May</th>
            <th v-bind:class="{'active-month': currentMonth == 6}"  scope="col">Jun</th>
            <th v-bind:class="{'active-month': currentMonth == 7}"  scope="col">Jul</th>
            <th v-bind:class="{'active-month': currentMonth == 8}"  scope="col">Aug</th>
            <th v-bind:class="{'active-month': currentMonth == 9}"  scope="col">Sep</th>
            <th v-bind:class="{'active-month': currentMonth == 10}" scope="col">Oct</th>
            <th v-bind:class="{'active-month': currentMonth == 11}" scope="col">Nov</th>
            <th v-bind:class="{'active-month': currentMonth == 12}" scope="col">Dec</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="(propertyFee, key, index) in propertyFees">
                <td scope="row"><strong>Expense Cost</strong></td>
                <td v-bind:class="{'active-month-column': currentMonth == (key2 )}" v-for="(fee, key2) in propertyFee.fees">
                    <div v-if="key2 <= 12">
                        <div v-if="key2 > currentMonth">
                            -
                        </div>
                        <div v-else>
                            <div v-if="key2 < currentMonth && key2 > 0">
                                <div v-if="fee == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee) }}
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="fee == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="fee == 0">
                            -
                        </div>
                        <div v-else>
                            {{ $filters.toCurrency(fee) }}
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-for="(payment, key, index) in payments">
                <td scope="row"><strong>Payments</strong></td>
                <td v-bind:class="{'active-month-column': currentMonth == (key3 )}" v-for="(fee2, key3) in payment.fees">
                    <div v-if="key3 <= 12">
                        <div v-if="key3 > currentMonth">
                            -
                        </div>
                        <div v-else>
                            <div v-if="key3 <= currentMonth && key3 > 0">
                                <div v-if="fee2 == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee2) }}
                                </div>
                            </div>
                            <div v-else>
                                <a> - </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="fee2 == 0">
                            -
                        </div>
                        <div v-else>
                            {{ $filters.toCurrency(fee2) }}
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-for="(payment, key, index) in creditNotes">
                <td scope="row"><strong>Credit Notes</strong></td>
                <td v-bind:class="{'active-month-column': currentMonth == (key3 )}" v-for="(fee2, key3) in payment.fees">
                    <div v-if="key3 <= 12">
                        <div v-if="key3 > currentMonth">
                            -
                        </div>
                        <div v-else>
                            <div v-if="key3 <= currentMonth && key3 > 0">
                                <div v-if="fee2 == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee2) }}
                                </div>
                            </div>
                            <div v-else>
                                <a> - </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="fee2 == 0">
                            -
                        </div>
                        <div v-else>
                            {{ $filters.toCurrency(fee2) }}
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td scope="row">
                    <strong>Balance</strong>
                </td>
                <td v-bind:class="{'active-month-column': currentMonth == (key4 )}" v-for="(total, key4) in totalFees">
                    <div v-if="key4 <= 12">
                        <div v-if="key4 > currentMonth">
                            <a> - </a>
                        </div>
                        <div v-else>
                            <div v-if="key4 < currentMonth && key4 > 0">
                                <div v-if="total == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(total) }}
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="total == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(total) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="total == 0">
                            -
                        </div>
                        <div v-else>
                            {{ $filters.toCurrency(total) }}
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { expenseTypeService } from "@/_services";
export default {
  props: [ "route",  "period", "owner", "unitId"],
  data: function () {
    return {
      propertyFees: [],
      totalFees: [],
      index: 0,
      isModalVisible: true,
      monthParam: 0,
        payments: [],
        creditNotes: [],
      year: 0,
      currentMonth: 12,
      expenseTypeId: 1,
      expenseTypes: [],
    };
  },
  watch: {
    value(val) {
      this.$emit("update:propertyId", val);

    },
    value2(val) {
      this.$emit("update:unitId", val);

    },
    propertyId(val) {
      this.value = val;
      this.fetchStatement();
    },
    unitId(val){
        this.value2 = val;
        this.fetchStatement();
    }
  },
  mounted() {
    if (!this.$period.isCurrent(this.period)) {
      this.currentMonth = 12;
      this.year = new Date().getFullYear() - Number(this.period);
    } else {
      this.year = new Date().getFullYear() - 1;
      this.currentMonth = new Date().getMonth() + 1;
    }
this. getExpenseTypes();
     this.fetchStatement();
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    getExpenseTypes() {
      console.log("Building id 1: " + this.buildingId)
      expenseTypeService
        .getExpenseTypesOfBuilding(this.buildingId)
        .then((data) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.expenseTypes = data.expenseTypes;

          // this.expenseTypeId = this.expenseTypes[0].id;
          this.expenseTypeId = data.selectexExpenseTypeId.id;
          this.fetchStatement();
        });
    },
    beforeOpen(event) {
      this.propertyId = event.params.creditortypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {
      var request = "/statement/propertyexpense";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request =
        request +
        "?id=" +
        (this.owner ? this.propertyId : this.unitId) +
        "&expenseId=" +
        this.expenseTypeId +
        "&period=" +
        this.period;
      /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/

      this.$http
        .get(request, {
          id: (this.owner ? this.propertyId : this.unitId),
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.propertyFees = data.propertyFees;
          this.totalFees = data.totalFees;
            this.payments = data.paymentFees;
            this.creditNotes = data.creditNoteFees;
        });
    },
    showModalTemp: function (propertyId, month) {
      //this.$modal.show('creditors-form', { 'creditortypeid': creditorId,  'month' : month});
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      // this.$modal.show('creditors-form');
    },
    hide() {
      // this.$modal.hide('creditors-form');
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      property:(state)=>state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.property != null && this.property!= undefined && this.owner)
        return  this.property.buildingName;
    if(this.building != null && this.building!= undefined)
    return  this.building.name;
      return ""
    },
    buildingId(){
        if(this.property != null && this.property!= undefined && this.owner)
        return  this.property.buildingId;
        if(this.building != null && this.building!= undefined)
    return  this.building.id;
      return ""
    },
    propertyId(){
      if(this.property != null)
        return  this.property.id;
      return ""
    },
    propertyName(){
      if(this.property != null)
        return  this.property.propertyName;
      return ""
    },
    total: function () {
      console.log(this.propertyFees);
      return this.propertyFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
  },
}; // Our Javascript logic
</script>
